module.exports = __webpack_public_path__ + "img/metal_at@2x.51bff2b0.png";